import { render } from "./PageNotFound.vue?vue&type=template&id=2bb2b5af&scoped=true"
const script = {}

import "./PageNotFound.vue?vue&type=style&index=0&id=2bb2b5af&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bb2b5af"]])

export default __exports__